import {secureFetch} from "./authService";
import {API_BASE_URL, API_UPLOAD_URL, PAGINATION_DEFAULT_LIMIT, SUPER_ADMIN} from "./constants";

export function getCompanies(query) {
	let url = API_BASE_URL + '/company?';
	if (query) {
		const {
			page = 0,
			filters,
			limit = PAGINATION_DEFAULT_LIMIT,
			lang
		} = query;

		if (limit) {
			url = url + `&limit=${limit}`;
		}

		if (page || page === 0) {
			url = url + `&page=${page}`;
		}

		if (lang) {
			url = url + `&lang=${query.lang}`
		}

		if (filters && filters.length) {
			console.log('filters', filters);
			filters.forEach(filter => {
				if (filter.value) {
					url = url + `&${filter.name}=${filter.value}`;
				}
			});
		}
	}
	return secureFetch(url, {
		method: 'GET',
	});
}

export function getTinyCompanies() {
	let url = API_BASE_URL + '/company/tiny?';
	return secureFetch(url, {
		method: 'GET',
	});
}

export function getTinyCompaniesWithOperator(operatorId) {
	let url = API_BASE_URL + '/company/tiny/withOperator?';
	if (operatorId) {
		url = url + `&operatorId=${operatorId}`;
	}
	return secureFetch(url, {
		method: 'GET',
	});
}

export function getSelectedCompanies(companyIds) {
	return secureFetch(API_BASE_URL + '/company/batch', {
		method: 'POST',
		body: JSON.stringify(companyIds)
	});
}

export function addCompany(company) {
	return secureFetch(API_BASE_URL + '/company', {
		method: 'POST',
		body: JSON.stringify(company)
	});
}

export function deleteCompany(companyId) {
	return secureFetch(API_BASE_URL + '/company/' + companyId, {
		method: 'DELETE'
	});
}

export function updateCompany(company) {
	return secureFetch(API_BASE_URL + '/company/' + company.id, {
		method: 'PUT',
		body: JSON.stringify(company)
	});
}

export function uploadLogo(companyId, logo) {
	return secureFetch(API_UPLOAD_URL + '/company/logo/' + companyId, {
		method: 'POST',
		body: logo
	}, {});
}

export function deleteLogo(companyId) {
	return secureFetch(API_BASE_URL + '/company/logo/' + companyId, {
		method: 'DELETE'
	});
}

export function getCompanyAvailableLanguages() {
	let url = API_BASE_URL + '/company/language?';
	return secureFetch(url, {
		method: 'GET',
	});
}

export function getOperatorTinyCompanies() {
	let url = API_BASE_URL + '/company/operators/tiny?';
	return secureFetch(url, {
		method: 'GET',
	});
}


export const isStatisticPermission = (company, authority) => {
	return hasPermissionForAttribute(company, authority,'AllowStatistic');
}

export const isSupportChatPermission = (company, authority) => {
	return hasPermissionForAttribute(company, authority,'AllowSupportChat');
}

export const isCompanyLogoPermission = (company, authority) => {
	return hasPermissionForAttribute(company, authority,'AllowCompanyLogo');
}

export const isLoansPermission = (company, authority) => {
	return hasPermissionForAttribute(company, authority,'AllowLoans');
}

export const isPlayerPermission = (company, authority) => {
	return hasPermissionForAttribute(company, authority,'AllowPlayer');
}

export const isPromoterPermission = (company, authority) => {
	return hasPermissionForAttribute(company, authority,'AllowPromoter');
}

export const isPAFeaturesVisible = (company, authority) => {
	return hasPermissionForAttribute(company, authority,'ShowPAFeatures');
}

export const hasGeoActivityPermission = (company, authority) => {
	return hasPermissionForAttribute(company, authority,'AllowGeoActivity');
}

export const hasPermissionForAttribute = (object, authority, attributeLabel) => {
	if (authority === SUPER_ADMIN) {
		return true;
	}

	const attribute = object.attributes.find(attribute => attribute.attribute
		&& attribute.attribute.label === attributeLabel);
	return attribute && attribute.value === 'true';
}


// WEBPACK FOOTER //
// ./src/helpers/companyService.js